import React from 'react';

import { useQuery } from '@apollo/client';

import {
  LeadDetails,
  LeadDetailsVariables,
} from '../../graphql/athena/queries/__generated__/LeadDetails';
import { LwcDetails_odProtosListingsServicesListwithcertaintyproduct_getLwcDetails_lwcDetails as LwcDetails } from '../../graphql/athena/queries/__generated__/LwcDetails';
import { LEAD_DETAILS_QUERY } from '../../graphql/athena/queries/LeadDetails';
import { useGetExteriorAssessmentData } from '../../graphql/athena/useExteriorAssessment';
import { convertLeadDetails } from '../../helpers/getAllLeadData';
import { LeadCard } from './LeadCard';

/**
 * Wrapper for a LeadCard
 * storybook-check-ignore
 */
interface LeadCardWrapperProps {
  lwcDetails: LwcDetails;
  agentCustomerUuid: string;
  tokenToShowDetailsFor?: string;
}

/** Wrapper for a LeadCard that does data fetching */
export const LeadCardWrapper: React.FC<LeadCardWrapperProps> = ({
  lwcDetails: lwcLeadDetail,
  tokenToShowDetailsFor,
  agentCustomerUuid,
}) => {
  const { loading, error, data } = useQuery<LeadDetails, LeadDetailsVariables>(LEAD_DETAILS_QUERY, {
    context: {
      clientName: 'athena',
    },
    variables: { selldirectLeadToken: lwcLeadDetail.lwcProduct?.sellerLeadToken ?? '' },
  });

  const { data: exteriorAssessmentData, loading: exteriorAssessmentDataLoading } =
    useGetExteriorAssessmentData(
      data?.odProtosListingsServicesListwithcertaintyproduct.getSellDirectDetails?.lead
        ?.sellerInputUuid,
    );

  if (loading || exteriorAssessmentDataLoading) return <p>Loading...</p>;
  if (error) return null;

  if (
    !data ||
    !lwcLeadDetail.lwcProduct ||
    !lwcLeadDetail.listing ||
    !lwcLeadDetail.agentLead ||
    !lwcLeadDetail.agentLead.id
  ) {
    return null;
  }

  const convertedDetails = convertLeadDetails(data, lwcLeadDetail, exteriorAssessmentData);
  const { lwcProductData, offerData, customerData } = convertedDetails;

  return (
    <LeadCard
      key={lwcProductData.token}
      name={customerData?.name}
      expiresAt={offerData?.expiresAt}
      token={lwcProductData.token}
      agentLeadId={lwcLeadDetail.agentLead.id}
      agentCustomerUuid={agentCustomerUuid}
      tokenToShowDetailsFor={tokenToShowDetailsFor}
      singleLead={convertedDetails}
      isALALead={offerData?.isALALead}
    />
  );
};
